module.exports = __webpack_public_path__ + "static/media/Plus.b1c01eac.svg";